import { render } from "./SetupLoginMethod.vue?vue&type=template&id=a4de0d1e"
import script from "./SetupLoginMethod.vue?vue&type=script&lang=js"
export * from "./SetupLoginMethod.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__